import { SvgIconProps } from "@mui/material";

import CaretRight from "./CaretRight";

const CaretLeft = ({ sx, ...rest }: SvgIconProps): JSX.Element => {
	return <CaretRight {...rest} sx={{ ...sx, transform: "scale(-1, 1)" }} />;
};

export default CaretLeft;
